export default "__VITE_ASSET__CD0fPS5k__"